/**
 * Cart recommendations ("You may also like")
 * Fetches Shopify's native product recommendations for the most
 * recently added cart item and renders them into the cart drawer
 * and/or the full cart page. See snippets/cart-recommendations.liquid.
 */
(function () {
  function moneyFormat(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var defaultFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    format = format || defaultFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholderRegex);
    var kind = match ? match[1] : 'amount';
    var value;

    switch (kind) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderRecommendations(container, grid, products) {
    if (!products || !products.length) {
      container.style.display = 'none';
      grid.innerHTML = '';
      return;
    }

    var cards = products.slice(0, 4).map(function (product) {
      var image = product.featured_image || (product.images && product.images[0]) || '';
      if (image && image.indexOf('//') === 0) {
        image = 'https:' + image;
      }
      var price = moneyFormat(product.price);
      var title = escapeHtml(product.title);
      var imageTag = image
        ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">'
        : '';

      return (
        '<a href="' + escapeHtml(product.url) + '" class="cart-recommendations__item">' +
        imageTag +
        '<span class="cart-recommendations__item-title">' + title + '</span>' +
        '<span class="cart-recommendations__item-price">' + price + '</span>' +
        '</a>'
      );
    });

    grid.innerHTML = cards.join('');
    container.style.display = '';
  }

  function fetchAndRender(container, grid, productId, excludeIds) {
    if (!productId) {
      container.style.display = 'none';
      return;
    }

    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=related';

    fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data || !data.products) {
          container.style.display = 'none';
          return;
        }
        var filtered = data.products.filter(function (product) {
          return (excludeIds || []).indexOf(product.id) === -1;
        });
        renderRecommendations(container, grid, filtered);
      })
      .catch(function () {
        container.style.display = 'none';
      });
  }

  function updateFromCart(container, grid, cart) {
    if (!cart || !cart.items || !cart.items.length) {
      container.style.display = 'none';
      return;
    }
    var productIds = cart.items.map(function (item) {
      return item.product_id;
    });
    var lastId = productIds[productIds.length - 1];
    fetchAndRender(container, grid, lastId, productIds);
  }

  function initContainer(container) {
    if (container.getAttribute('data-cart-rec-init') === 'true') {
      return;
    }
    container.setAttribute('data-cart-rec-init', 'true');

    var grid = container.querySelector('.cart-recommendations__grid');
    if (!grid) {
      return;
    }

    var idsAttr = container.getAttribute('data-cart-product-ids') || '';
    var productIds = idsAttr
      .split(',')
      .filter(function (id) { return id; })
      .map(function (id) { return parseInt(id, 10); });
    var lastId = container.getAttribute('data-last-product-id');

    if (lastId) {
      fetchAndRender(container, grid, parseInt(lastId, 10), productIds);
    } else {
      container.style.display = 'none';
    }

    if (window.jQuery) {
      window.jQuery('body').on('updateCart.ajaxcart', function (event, cart) {
        updateFromCart(container, grid, cart);
      });
    }
  }

  function init() {
    var containers = document.querySelectorAll('.cart-recommendations');
    for (var i = 0; i < containers.length; i++) {
      initContainer(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
